import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AssistantTriggerComponent } from "./components/assistant-trigger/assistant-trigger.component";
import { AssistantPopupComponent } from "./components/popup/assistant-popup/assistant-popup.component";
import { AssistantPopupHeaderComponent } from "./components/popup/assistant-popup-header/assistant-popup-header.component";
import { AssistantPopupContentComponent } from "./components/popup/assistant-popup-content/assistant-popup-content.component";
import { AssistantPopupStepsComponent } from "./components/popup/assistant-popup-steps/assistant-popup-steps.component";
import { AssistantPopupActionButtonsComponent } from "./components/popup/assistant-popup-action-buttons/assistant-popup-action-buttons.component";
import { AssistantPopupContentMessageComponent } from "./components/popup/assistant-popup-content-message/assistant-popup-content-message.component";
import { AssistantBannerComponent } from "./components/banner/assistant-banner/assistant-banner.component";
import { AssistantBannerActionButtonsComponent } from "./components/banner/assistant-banner-action-buttons/assistant-banner-action-buttons.component";
import { AssistantBannerContentComponent } from "./components/banner/assistant-banner-content/assistant-banner-content.component";
import { AssistantBannerContentMessageComponent } from "./components/banner/assistant-banner-content-message/assistant-banner-content-message.component";
import { AssistantBannerContentLinksComponent } from "./components/banner/assistant-banner-content-links/assistant-banner-content-links.component";

@NgModule({
  declarations: [
    AssistantTriggerComponent,
    AssistantPopupComponent,
    AssistantPopupHeaderComponent,
    AssistantPopupContentComponent,
    AssistantPopupStepsComponent,
    AssistantPopupActionButtonsComponent,
    AssistantPopupContentMessageComponent,
    AssistantBannerComponent,
    AssistantBannerActionButtonsComponent,
    AssistantBannerContentComponent,
    AssistantBannerContentMessageComponent,
    AssistantBannerContentLinksComponent,
  ],
  imports: [SharedModule],
  exports: [AssistantTriggerComponent],
})
export class AssistantModule {}
